import { TAB_NAMES } from 'shared/constants/app-settings-tabs';


const prefix = '/widget/cb6480f3-768b-4737-ab8f-10fe2e4fa2ab/article/';


export const APP_SETTINGS = {
  [TAB_NAMES.MAIN]: '758dcf00-c1fd-49db-a765-20dc9e38dd83',
  [TAB_NAMES.CHANNEL]: 'd76eaf25-334a-4e3c-a126-69d7de75bfc3',
  [TAB_NAMES.LAYOUT]: '499ed25b-b835-44d7-92e4-a5a081640db6',
  [TAB_NAMES.SETTINGS]: '5c6d9ef8-4e72-4654-9335-26a5aed788c7',
  [TAB_NAMES.PLAYER]: 'e3b61623-dccf-46b4-96cf-31011d014812',
  [TAB_NAMES.DESIGN]: '2c44e7d4-2a6c-40ad-b0b6-39bed20a744c',
};

export const DASHBOARD = {
  LIBRARY: `${prefix}a9755854-f70e-4875-9114-1c4361e75b23`,
  CHANNELS: `${prefix}d76eaf25-334a-4e3c-a126-69d7de75bfc3`,
  STATS: `${prefix}3b8e4c51-916f-4e62-b678-c2875dc57312`,
  SETTINGS: `${prefix}d60e85d5-320e-4181-845b-66d3e7de87e1`,
  EMAIL_MARKETING: `${prefix}caa7bf38-3b47-4d02-810a-01c68e087a59`,
};

export const DASHBOARD_ADI = `${prefix}450a45ef-5649-468c-8927-f59652a93f62`;

export const HELP_LINK_PREFIX = 'https://www.wix.com/support/html5';

export const PREVIEW_MODAL = '53d47bf8-43ec-4d26-9ac7-05e8bb6504cf';



// WEBPACK FOOTER //
// ./src/shared/constants/help-articles.js